import * as LabelPrimitive from "@radix-ui/react-label";
import React from "react";

import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

const ServerFormItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn("space-y-2", className)} {...props} />;
});
ServerFormItem.displayName = "FormItem";

type Error = {
  error?: {
    _errors: string[];
  };
};

const ServerFormLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root> & Error,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & Error
>(({ className, ...props }, ref) => {
  return (
    <Label
      ref={ref}
      className={cn(props.error && "text-red-500", className)}
      htmlFor={props.htmlFor}
      {...props}
    />
  );
});
ServerFormLabel.displayName = "FormLabel";

const ServerFormDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => {
  return (
    <p
      ref={ref}
      id={props.id}
      className={cn("text-[0.8rem] text-muted-foreground", className)}
      {...props}
    />
  );
});
ServerFormDescription.displayName = "FormDescription";

const ServerFormMessage = React.forwardRef<
  HTMLParagraphElement & Error,
  React.HTMLAttributes<HTMLParagraphElement> & Error
>(({ className, children, error, ...props }, ref) => {
  const body = error ? String(error._errors.join(", ")) : children;

  if (!body) {
    return null;
  }

  return (
    <p
      ref={ref}
      className={cn("text-[0.8rem] font-medium text-red-500", className)}
      {...props}
    >
      {body}
    </p>
  );
});
ServerFormMessage.displayName = "FormMessage";

export {
  ServerFormDescription as ServerFormDescription,
  ServerFormItem as ServerFormItem,
  ServerFormLabel as ServerFormLabel,
  ServerFormMessage as ServerFormMessage,
};
